
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import router from '../../router';
import { Point } from '../../shared/contracts/AnswerContract';
import { eventService } from "../../shared/services/EventService";
import { localStorageService } from '../../shared/services/LocalStorageService';
import { IBarometerState, IUserState } from '../../store/contract';
import JoeyBrandName from '../branding/JoeyBrandName.vue';
import JoeyLogo from '../branding/JoeyLogo.vue';
import JoeyLoading from '../shared/JoeyLoading.vue';
import JoeyMessageGroup from './JoeyMessageGroup.vue';
import {
    ActionsMessageModel,
    AuthorType,
    ConversationModel,
    MessageAction,
    MessageModel,
    TextMessageModel
} from './MessageModel';

const userNamespace: string = 'user';
const barometerNamespace: string = 'barometer';

@Component({
    components: {
        JoeyLogo,
        JoeyBrandName,
        JoeyLoading,
        JoeyMessageGroup
    }
})
export default class JoeyChatbot extends Vue {
    @State(userNamespace) userState: IUserState;
    @State(barometerNamespace) barometerState: IBarometerState;

    public isJoeyActive = false;
    public isJoeyThinking = false;
    public conversation = new ConversationModel();

    public toggleJoey() {
        if (this.isJoeyActive) {
            eventService.track('Chat', 'Close');
            localStorageService.setChatbotClosed();
        } else {
            eventService.track('Chat', 'Open');
        }
        this.isJoeyActive = !this.isJoeyActive;
    }

    private created() {
        setTimeout(() => {
            if (this.joeyShouldAsk()) {
                this.isJoeyActive = true;
            }
            this.startConversation();
        }, 2000);
    }

    private joeyShouldAsk(): boolean {
        if (!this.userState.user.isParticipant || !this.userIsViewingOwnBarometer() || this.chatWasRecentlyClosed()) {
            return false;
        }
        const snapshotsCount = this.barometerState.currentBarometer.snapshots.length;
        if (snapshotsCount === 0) {
            return true;
        }
        return moment(this.barometerState.currentBarometer.snapshots[snapshotsCount - 1].date)
            .add(3, 'months')
            .isBefore(moment());
    }

    private userIsViewingOwnBarometer() {
        return (
            this.barometerState.currentBarometer &&
            this.barometerState.currentBarometer.participant &&
            this.barometerState.currentBarometer.participant.id === this.userState.user.id
        );
    }

    private chatWasRecentlyClosed() {
        const joeyWasClosed = localStorageService.getChatbotClosed();
        return joeyWasClosed && joeyWasClosed.add(1, 'hours').isAfter(moment());
    }

    /**
     * Move this to a conversation service, in charge of getting the answers from the server.
     */

    private async startConversation() {
        const message = new TextMessageModel(AuthorType.Joey, `Hi ${this.userState.user.firstName}!`);
        await this.addMessage(message, 500);
        const message2 = new TextMessageModel(AuthorType.Joey, `I'm Joey.`);
        await this.addMessage(message2, 1000);
        await this.addActionMessage(1500);
    }

    private async addMessage(message: MessageModel, timeoutTime: number = 1500) {
        return new Promise<void>((resolve, reject) => {
            this.isJoeyThinking = true;
            setTimeout(() => {
                this.isJoeyThinking = false;
                this.conversation.addMessage(message);
                setTimeout(() => resolve(), 200);
            }, timeoutTime);
        });
    }

    private async addActionMessage(timeoutTime: number = 1500) {
        const actions = [];
        actions.push(
            new MessageAction('Great!', () => {
                eventService.track('Chat', 'Go to Barometer', 'Positive');
                router.push({ name: 'consultantQuestionnaire', params: { prefilledAnswer: Point.Positive } });
                }
            )
        );
        actions.push(
            new MessageAction('So so...', () => {
                eventService.track('Chat', 'Go to Barometer','Neutral');
                router.push({ name: 'consultantQuestionnaire', params: { prefilledAnswer: Point.Neutral } });
                }
            )
        );
        actions.push(
            new MessageAction('Not that great.', () => {
                eventService.track('Chat', 'Go to Barometer','Negative');
                router.push({ name: 'consultantQuestionnaire', params: { prefilledAnswer: Point.Negative } });
                }
            )
        );
        return this.addMessage(new ActionsMessageModel(AuthorType.Joey, `How you doin'?`, actions));
    }
}
